import styled, { css } from 'styled-components';
import { Colors } from './Colors';

export type ActionItemProps = {
    color?: string,
    disabled?: boolean,
    grow?: boolean,
    pressable?: boolean,
    selected?: boolean,
};

export const ActionItem = styled.div<ActionItemProps>`
    position: relative;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    font-weight: 450;
    color: ${p => p.color ?? Colors.primaryText};
    flex: ${p => p.grow ? '1 1 auto' : '0 0 auto'};
    user-select: none;

    &:hover {
        background-color: ${Colors.primaryHover};
        cursor: pointer;
    }

    ${p => !p.pressable ? '' : css`
        &:active {
            background-color: ${Colors.primaryPress};
        }
    `}

    &:last-child {
        border: none
    }

    > span {
        margin: 0 .5rem;
    }

    ${p => !p.disabled ? '' : css`
        pointer-events: none;
        color: gainsboro;
    `}

    ${p => !p.selected ? '' : css`
        &:after {
            content: '';
            position: absolute;
            top: .25rem;
            left: .25rem;
            right: .25rem;
            bottom: .25rem;
            background: ${Colors.primarySelected};
            border-radius: 0.25rem;
        }
    `}

    &:hover, &:active {
        &:after { display: none }
    }
    
`;
